import type { CalendarSharePermission } from '@/api'

// The label of a calendar sharing grant, for the calendar's own sharing panel and the settings overview.
export function grantLabel(
  grant: CalendarSharePermission,
  t: (key: string, named?: Record<string, unknown>) => string,
): string {
  if (grant.permission_type === 'specific_user')
    return t('accounts.grantUser', { name: grant.target_username ?? grant.target_telegram_user_id })
  if (grant.permission_type === 'specific_chat')
    return t('accounts.grantChat', { id: grant.target_chat_id })
  return t(grant.permission_type === 'everyone' ? 'accounts.shareEveryone' : 'accounts.shareAnyGroup')
}
